export default __webpack_public_path__ + "static/media/chrome-phone-3.5fdfb582.jpg";